import React from "react";
import { ArrowLeft, LoaderCircle, RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LegacyFaceCaptureAdapter } from "../adapters/LegacyFaceCaptureAdapter";
import { KycStep } from "../components/KycStep";

export function LivenessStep({
  session,
  liveness,
  completedAttempts,
  error: submissionError,
  busy,
  onChange,
  onBack,
  onContinue,
}) {
  const { t } = useTranslation();

  return (
    <KycStep labelledBy="kyc-liveness-title" className="liveness-step">
      <h1 id="kyc-liveness-title" className="sr-only">
        {t("kyc.liveness.title")}
      </h1>

      <div className="mx-auto mb-3 flex w-full max-w-md justify-start">
        <button
          type="button"
          onClick={onBack}
          disabled={busy}
          className="liveness-back inline-flex min-h-10 items-center justify-center gap-1.5 rounded-lg px-2 text-sm font-semibold text-slate-500 transition hover:bg-slate-50 hover:text-slate-900 disabled:opacity-50"
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          {t("common.back")}
        </button>
      </div>

      <div>
        <LegacyFaceCaptureAdapter
          session={session}
          completedAttempts={completedAttempts}
          onComplete={(value) => {
            const completedLiveness = {
              value: value || "",
              completed: Boolean(value),
            };
            onChange(completedLiveness);
            onContinue(completedLiveness);
          }}
        />
      </div>
      {submissionError && (
        <p className="mt-3 text-center text-xs text-red-700" role="alert">
          {submissionError}
        </p>
      )}

      {submissionError && liveness.completed && liveness.value && (
        <button
          type="button"
          onClick={() => onContinue(liveness)}
          disabled={busy}
          className="btn-primary mx-auto mt-3 w-full max-w-md"
        >
          {busy ? (
            <LoaderCircle className="size-4 animate-spin" aria-hidden="true" />
          ) : (
            <RotateCcw className="size-4" aria-hidden="true" />
          )}
          {busy
            ? t("kyc.liveness.submitting")
            : t("kyc.liveness.detection.retryProcessing")}
        </button>
      )}
    </KycStep>
  );
}
